<main class="seo-page" *ngIf="page as content">
  <section class="seo-hero">
    <p class="seo-pill">Java Streams Guides</p>
    <h1>{{ content.title }}</h1>
    <p class="seo-lead">{{ content.lead }}</p>
    <div class="seo-actions">
      <a class="btn-primary" routerLink="/problems">Browse problems</a>
      <a class="btn-secondary" routerLink="/auth">Start practicing</a>
    </div>
  </section>

  <section class="seo-content">
    <article class="seo-section" *ngFor="let section of content.sections">
      <h2>{{ section.heading }}</h2>
      <p *ngFor="let paragraph of section.body">{{ paragraph }}</p>
      <ul *ngIf="section.bullets?.length">
        <li *ngFor="let item of section.bullets">{{ item }}</li>
      </ul>
    </article>
  </section>
</main>
